import { render, staticRenderFns } from "./pill.global.vue?vue&type=template&id=28edbb40&functional=true&"
import script from "./pill.global.vue?vue&type=script&lang=js&"
export * from "./pill.global.vue?vue&type=script&lang=js&"
import style0 from "./pill.global.vue?vue&type=style&index=0&id=28edbb40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports